import React from 'react'
import ButtonV2 from 'Components/Buttons/ButtonV2'

import { IconButton, Dialog, DialogTitle, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const styles = {
  modal: {
    '& .MuiDialog-paper': {
      maxWidth: 632,
      width: '100%',
      paddingBottom: 46,
    },
    '& .MuiDialogTitle-root': {
      padding: '10px 10px 0px',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 20px 32px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0px',
  },

  mockHeight: {
    height: 30,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 24px',
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: '#011533',
    lineHeight: '30px',
    marginTop: 16,
    marginBottom: 10,
    fontFamily: 'Proxima Nova, sans-serif',
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    color: '#011533',
    lineHeight: '22px',
    fontFamily: 'Proxima Nova, sans-serif',
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 40,
    width: '364px',
    height: 40,
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

const useStyles = makeStyles(styles)

const ModalV2 = ({
  isOpen = false,
  onClose = () => {},
  isHideCloseButton = false,
  title,
  description,
  buttons = [],
  icon,
}) => {
  const classes = useStyles()
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      className={classes.modal}
      disableBackdropClick={isHideCloseButton}
      disableEscapeKeyDown={isHideCloseButton}
    >
      <DialogTitle>
        <div className={classes.titleContainer}>
          {isHideCloseButton ? (
            <div className={classes.mockHeight} />
          ) : (
            <IconButton onClick={onClose} size="small">
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </DialogTitle>
      <div className={classes.content}>
        {icon ? <div className={classes.iconContainer}>{icon}</div> : null}
        <div className={classes.title}>{title}</div>
        <div className={classes.description}>{description}</div>
        {buttons.length ? (
          <div className={classes.buttonContainer}>
            {buttons.map((button, index) => (
              <ButtonV2
                key={index}
                outlined={button.outlined}
                label={button.label}
                onClick={button.onClick}
                styles={{ width: 146 }}
              />
            ))}
          </div>
        ) : null}
      </div>
    </Dialog>
  )
}

export default ModalV2
